import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'proficiency',
  pure: true
})
export class ProficiencyPipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('Unknown level');
    }
    const id = String(value);
    return this.lookupData.getLanguageProficiencies({
      selectedIds: [id],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const found = result.items.find(p => String(p.id) === id);
        return found ? found.name : 'Unknown level';
      })
    );
  }
}
